// @ts-nocheck
import React, { useRef, useState } from "react";
import { useQueryClient } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
// eslint-disable-next-line
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import useAccount from "classes/Accounts/hooks/useAccount";
import AuthorPreview from "components/User/AuthorPreview/AuthorPreview";
import genRequest from "includes/request";
import { t } from "i18next";
import Markdown from "markdown-to-jsx";
import moment from "moment";
import "moment/dist/locale/fr";
import "./Comments.css";
import LoadCont from "components/LoadCont/LoadCont";
import ErrorsCont from "components/ErrorsCont/ErrorsCont";
import Button from "components/Button/Button";
import clsx from "clsx";

export default function Comments(props) {
	const coms_cont_ref = useRef();
	const { items, isMobile } = props;
	const [isEditing, setIsEditing] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const handleComment = () => {
		if (props.onComment && props.showComments !== false) {
			if (props.onComment) {
				let req = props.onComment();
				setIsMenuOpen(false);
				if (req.then)
					req.then(scrollCont);
			}
			scrollCont();
		}
	};

	const handleModify = (com) => setIsEditing(com);

	const scrollCont = () => {
		if (coms_cont_ref?.current)
			coms_cont_ref.current.scrollTop = 0;
	};

	return (
		<div className={clsx(props.className, isMobile && " commentMobile")}>

			{isMobile && <div>
				<div className="nbre_comments mobile">{items.length} {t("Posts.COMMENTS")}</div>
				{items.length === 0 && <div class="nbre_comments_text">{t("Posts.NO_COMMENTS_TEXT")}</div>}
			</div>}
			{
				props.showComments &&
				<div className="comments-cont" ref={coms_cont_ref}>
					{
						(items?.length) ?
							items.map((com) => {
								return (<Comment isMobile={isMobile} key={com.commentId} comment={com} {...com} handleModify={() => handleModify(com)} />);
							})
							:
							<div>
								{!isMobile && t("Posts.NO_COMMENT")}
							</div>
					}
				</div>
			}
			{
				props.canComment !== false && !isMobile &&
				<CommentSender
					isMobile={isMobile}
					{...props}
					isEditing={isEditing || false}
					closeEdit={() => setIsEditing(false)}
					comment={isEditing}
					onComment={handleComment}
				/>
			}
			{isMobile && <div className={clsx("wrapper-mobile-commentSender", isMenuOpen && "open")}>
				<div className="showCommentSenderBtn">

					<Button className=" headbar-add-btn btn btn-primary gap-2" onClick={() => { setIsMenuOpen(!isMenuOpen) }}>
						<span className="icons icon-edit f-25"></span>

					</Button>
					<span className="text">{t('Posts.COMMENT_TEXT')}</span>
				</div>
				<div className="container-commentSender">
					{
						props.canComment !== false &&
						<CommentSender
							{...props}
							isMobile={isMobile}
							isEditing={isEditing || false}
							closeEdit={() => setIsEditing(false)}
							comment={isEditing}
							onComment={handleComment}
						/>
					}
				</div>
			</div>
			}
		</div>
	);
}

function Comment(props) {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [tempDom, setTempDom] = useState(false);
	const [hasError, setHasError] = useState(false);

	return (
		<div
			className="comment"
			onMouseLeave={() => {
				if (isMenuOpen && !hasError)
					setIsMenuOpen(false);
			}}
		>
			{
				tempDom ?
					tempDom
					:
					<>
						<CommentHead isMobile={props.isMobile} menu={props.menu} comment={props.comment} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
						{
							(isMenuOpen && props.menu !== false) &&
							<CommentMenu comment={props.comment} handleModify={props.handleModify} setTempDom={setTempDom} setHasError={setHasError} />
						}
						<Markdown>
							{props.commentText.replace(/\n{1}/gi, "\n\n")}
						</Markdown>
					</>
			}

		</div>
	);
}

function CommentHead(props) {
	const { account, isAdmin } = useAccount();
	const { comment, setIsMenuOpen, isMenuOpen } = props;

	if (!comment)
		return (false);

	const isModified = () => {
		// Either field can be null from the API — a comment that's never been
		// edited has no lastChanged, and the seed occasionally omits
		// publishedDate. Truncate at the `.` separator only when present.
		const pub = comment.publishedDate?.split(".")[0];
		const chng = comment.lastChanged?.split(".")[0];
		if (!pub || !chng) return false;
		return chng > pub;
	};
	return (
		<>

			<div className={clsx("d-flex w-100 ")}>
				<div className="d-flex justify-content-between w-100">


					<AuthorPreview
						employeeId={comment.employeeId}
						className="comment-list-author-preview mb-2"
						format={
							[
								"firstName lastName",
								"WFU"
							]
						}
						modifiers={{
							lastName: (item) => item.toUpperCase()
						}}
					/>
					{!props.isMobile && <div className="me-1 comment-date d-flex">
						{
							isModified()
							&&
							<div className="text-grey me-1">
								({t("Comments.MODIFIED")})
							</div>
						}
						<span title={moment(comment.lastChanged).locale(t("Code")).format("D MMM YYYY HH:mm")}>
							{moment(comment.lastChanged).locale(t("Code")).fromNow()}
						</span>
						{
							props.menu !== false && (comment.employeeId === account.employeeId || isAdmin()) &&
							<div className="ms-1 cursor-pointer" onClick={() => setIsMenuOpen(!isMenuOpen)}>
								<FontAwesomeIcon icon={faEllipsisV} />
							</div>
						}
					</div>}
				</div>

			</div >
			{props.isMobile && <div className="mobile_comment-date">
				{/* {comment.lastChanged} */}
				{t("Commons.THE")}{" "}
				{moment(comment.lastChanged).locale(t("Code")).format("DD/MM/YYYY")}
				{" "}{t("Commons.AT")}{" "}
				{moment(comment.lastChanged).locale(t("Code")).format("HH:MM")}
			</div>}
		</>
	);
}

function CommentMenu(props) {
	const { account, isAdmin } = useAccount();
	const { comment, setHasError } = props;
	const [tempDom, setTempDom] = useState(false);
	const [errors, setErrors] = useState(false);
	const QCL = useQueryClient();

	const handleRemove = () => {
		setTempDom(<LoadCont text={t("Commons.DELETING")} />);
		let req = genRequest("posts/" + comment.postId + "/comments/" + comment.id, null, "delete").then(() => {
			QCL.refetchQueries(["Comments", "CommentOfPost", comment.postId]);
		}, () => {
			setTempDom(false);
			setHasError(true);
			setErrors(t("Comments.DELETE_ERROR"));
		});
		return (req);
	};

	return (
		<div className="CommentMenu mb-2">
			{
				tempDom ?
					tempDom
					:
					<>
						<ErrorsCont
							errors={errors}
							className="mb-2"
							setErrors={() => {
								setHasError(false);
								setErrors(false);
							}}
						/>
						<div className="comment-menu-items">
							{
								comment.employeeId === account.employeeId &&
								<div onClick={props.handleModify} title={t("Comments.REPORT_COMMENT")}>
									<FontAwesomeIcon color={"#00AAAA"} className="me-1" icon={faEdit} />
									{t("Commons.MODIFY")}
								</div>
							}
							{/* <div className="disabled" title={t("Comments.REPORT_COMMENT")}>
								<FontAwesomeIcon color={"#00AAAA"} className="me-1" icon={faFlag}/>
								{t("Commons.REPORT")}
							</div> */}
							{
								(comment.employeeId === account.employeeId || isAdmin()) &&
								<div onClick={handleRemove} title={t("Comments.DELETE_COMMENT")}>
									<FontAwesomeIcon color={"#DD0000"} className="me-1" icon={faTrashAlt} />
									{t("Commons.DELETE")}
								</div>
							}
						</div>
					</>
			}
		</div>
	);
}

function CommentSender(props) {
	const { comment, isMobile } = props;
	const input_ref = React.useRef();
	const [isSended, setIsSended] = useState(false);
	const [showBtn, setShowBtn] = useState(false);
	const [isSending, setIsSending] = useState(false);
	const [value, setValue] = useState(comment?.commentText || "");
	const { account } = useAccount();
	const isEditing = React.useRef(false);

	React.useEffect(() => {
		if (isEditing?.current !== props.comment) {
			isEditing.current = props.comment;
			if (props.isEditing && props.comment) {
				setValue(props.comment?.commentText);
				setIsSending(false);
				setIsSended(false);
			}
		}
	}, [isEditing, setValue, props]);

	function sendComment(e) {
		e.preventDefault();
		if (isSending || !value.length)
			return (false);
		setIsSending(true);
		let commentId = props.comment?.commentId;
		let data = { commentText: value };
		let req = genRequest(
			"posts/" + props.postId + "/comments" + (commentId ? "/" + commentId : ""),
			data,
			(commentId ? "put" : "post")
		).then((resp) => {
			setIsSended(resp);
			resetForm();

			if (props.onComment)
				props.onComment();
		}, () => {
			setIsSending(false);
			setIsSended(false);
		});
		return (req);
	}

	function resetForm() {
		setIsSending(false);
		setValue("");
		cancelEdit();
		if (input_ref?.current)
			input_ref.current.style.height = null;
	}

	function submitOnEnter(event) {
		if (event.which === 13 && !event.shiftKey && props.submitOnEnter)
			sendComment(event);
	}

	function auto_grow(e) {
		let elem = e.target;

		elem.style.height = "35px";
		elem.style.height = elem.scrollHeight + "px";
	}

	function cancelEdit() {
		setValue("");
		if (props.closeEdit())
			props.closeEdit();
	}

	if (isSended && (!props.onComment || !props.showComments)) {
		return (
			<div>
				<div className="mb-1">{t("Posts.RESP_SENDED")}</div>
				<Comment {...isSended} />
			</div>
		);
	}

	let txt = props.commentBtnTxt ? props.commentBtnTxt : t("Posts.RESP_SEND");
	if (isSending)
		txt = t("Commons.SENDING");

	return (
		<div className={clsx("write-comment-cont", !isMobile && "pt-4")}>
			{!isMobile && <div className="w-100">
				{
					(props.isEditing && props.comment) ?
						<div className="d-flex justify-content-between mb-1">
							<div>
								{t("Commons.MODIFY")}
							</div>
							<Button onClick={cancelEdit} className="w-auto btn-grey">{t("Commons.CANCEL")}</Button>
						</div>
						: t("Posts.REPLY")
				}
			</div>}
			{
				props.isEditing && props.comment &&
				<Comment menu={false} comment={props.comment} {...props.comment} />
			}
			<form className="d-flex align-items-start w-100 gap-2" onSubmit={sendComment}>
				<div className="w-100">
					<textarea
						ref={input_ref}
						disabled={isSending ? true : false}
						value={value}
						onChange={(e) => setValue(e.target.value)}
						className="w-100"
						placeholder={t("Posts.COMMENT_PH")}
						onKeyPressCapture={submitOnEnter}
						onChangeCapture={auto_grow}
						onFocus={(e) => isMobile && setShowBtn(true)}
						onBlur={(e) => isMobile && value == "" && setShowBtn(false)}
					/>
				</div>
				<div>
					{isMobile ? showBtn && <Button type="submit" className={clsx("btn-primary send-btn", isMobile && "mobile")} onClick={sendComment}>{isMobile && <span className="icons icon-send"></span>}{txt}</Button> : <Button type="submit" className={clsx("btn-primary send-btn", isMobile && "mobile")} onClick={sendComment}>{isMobile && <span className="icons icon-send"></span>}{txt}</Button>}
				</div>
			</form>
		</div>
	);
}
